import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";

const ConfigContext = createContext();

export const ConfigProviders = ({ children }) => {
  const [config, setConfig] = useState(() => {
    const saved = localStorage.getItem("appConfig");
    return saved
      ? JSON.parse(saved)
      : { treeView: false, RightPanel: true, FrontModal: false };
  });

  const location = useLocation();

  useEffect(() => {
    console.log(location.pathname, "location.pathname");
    const path = location.pathname;
    const segments = path.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1];
    if (lastSegment !== "admin") {
      setConfig((prev) => {
        const updated = {
          ...prev,
          RightPanel: true,
          FrontModal: false,
          treeView: false,
        };
        localStorage.setItem("appConfig", JSON.stringify(updated));
        return updated;
      });
    }
  }, [location.pathname]);

  const updateConfig = (newConfig) => {
    const updated = { ...config, ...newConfig };
    setConfig(updated);
    localStorage.setItem("appConfig", JSON.stringify(updated));
  };

  return (
    <ConfigContext.Provider value={{ config, updateConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
